<fieldset>
  <div class="fixed-section">
    <header class="fixed-top">
      <nav class="navbar navbar-expand-lg bg-white py-0">
        <div class="container-fluid pe-1">
          <a class="navbar-brand" href="index.html">
            <div class="d-flex">
              <div class="me-2">
                <img src="assets/images/logo_icon.png" class="logo_icon" alt="">
              </div>
              <div>
                <h6 class="projectName">RETAIL HUB</h6>
              </div>
              <div>
                <img src="assets/images/p&g_logo.png" class="pg_logo" alt="">
              </div>
            </div>
          </a>
          <!-- <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button> -->
          <div class="collapse navbar-collapse" id="navbarNav">
            <ul class="navbar-nav ms-auto">
              <li class="nav-item text-end align-self-center">
                <img src="assets/images/Walmart_icon.png" class="w-55" alt="">
              </li>


              <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle pe-0" href="#" role="button" data-bs-toggle="dropdown"
                  aria-expanded="false">
                  <img src="assets/images/gearIcon.svg" alt="" class="gearIcon">
                </a>
                <ul class="dropdown-menu l-114 py-1">
                  <li class="mb-1">
                    <a class="dropdown-item fs-13" href="#">
                      <div class="d-flex">
                        <div>
                          <img src="assets/images/settings_icon.svg" class="me-2" alt="">
                        </div>
                        <div>
                          SETTINGS
                        </div>
                      </div>
                    </a>
                  </li>
                  <li>
                    <a class="dropdown-item fs-13" href="#">
                      <div class="d-flex">
                        <div>
                          <img src="assets/images/sign_out.svg" class="me-2" alt="">
                        </div>
                        <div>
                          SIGN OUT
                        </div>
                      </div>
                    </a>
                  </li>
                </ul>
              </li>

            </ul>
          </div>
        </div>
      </nav>
    </header>



    <section class="titleBarBg fixed-top">
      <div class="container-fluid">
        <div class="row mar-7px">
          <div class="w-3">
            <img src="assets/images/newproject.svg" class="pageIcon" alt="">
          </div>
          <div class="w-97">
            <div class="pageHeadingBar">
              <div class="row">
                <div class="col-md-6 align-self-center">
                  <h6 class="pageHeadingText mb-0 text-uppercase">{{projectTitleDisplay}}</h6>
                </div>

                <div class="col-md-3 align-self-center">
                  <div class="d-flex">
                    <div class="nav-item dropdown">
                      <div class="button-container d-flex">
                        <div #saveDiv class="me-1 position-relative actionButton align-self-center dropdown-toggle"
                          data-bs-toggle="dropdown" aria-expanded="false" (click)="saveProject()">
                          <img src="assets/images/save_icon.svg" class="saveImg me-2" alt="" title="Save">
                          <span class="statusValue pe-2">SAVE</span>
                        </div>
                        <div #CancelDiv class="me-1 position-relative actionButton align-self-center dropdown-toggle"
                          data-bs-toggle="dropdown" aria-expanded="false" (click)="cancelProject()">
                          <img src="assets/images/closered_circle 1.png" class="saveImg me-2" alt="" title="Cancel">
                          <span class="statusValue pe-2">DELETE</span>
                        </div>
                      </div>

                      <!-- <div class="dropdown-menu validationDroupdown px-0 py-0 border-0">

                      <div class="card rounded-0 border-0">
                        <div class="card-header border-bottom rounded-0 py-2 alert alert-danger border-0 mb-0">
                          <div class="row">
                            <div class="col-md-10 align-self-center">
                              <div class="d-flex">
                                <img src="assets/images/warningIcon.png" class="w-16 me-2" alt="">
                              <h6 class="secHeading  text-start fw-bold alert-heading mb-0">VALIDATIONS</h6>
                              </div>
                            </div>
                            <div class="col-md-2 text-end">
                              <img src="assets/images/redclosemarkk.png" class="w-12 pb-1" alt="">
                            </div>
                          </div>
                        </div>
                        <div class="card-body alert alert-danger border-0 rounded-0 mb-0 pb-2">
                          <ul class="validations mb-0 ps-3 px-3">
                            <li>
                                Max file size allowed is 5 MB. We rejected one/more files were rejected
                            </li>
                            <li>
                                Zip files are not allowed. One/more files were rejected.
                            </li>
                            <li>
                                Project Title is a mandatory field.
                            </li>
                            <li>
                                PC date must be later than PE date
                            </li>
                        </ul>
                        </div>
                      </div>



                    </div> -->
                    </div>





                  </div>
                </div>
                <div class="col-md-3 align-self-center"></div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>


    <section class="mt-131 fixed-top fixedHeaderBg">
      <div class="container-fluid px-2">
        <div class="row">
          <div class="col-md-12">
            <div class="card border-0 stepsBars">
              <div class="card-body pb-0">
                <div class="main mx-2 pb-1 ms-0">
                  <div class="progressbar ml-34">
                    <ul>
                      <li>
                        <p class="label">INITIATED</p>
                      </li>
                      <li>
                        <p class="label">APPROVAL</p>
                      </li>
                      <li>
                        <p class="label">PWR LINKED</p>
                      </li>
                      <li>
                        <p class="label">EXECUTION STARTED</p>
                      </li>
                      <li>
                        <p class="label">EXECUTION COMPLETED</p>
                      </li>
                      <li>
                        <p class="label">VERIFIED</p>
                      </li>
                      <!-- <li>
                        <p class="label">COMPLETED</p>
                    </li> -->

                    </ul>
                  </div>

                  <div class="progressbar mb-2 ml-34">
                    <ul>
                      <li>
                        <div class="border-div">
                          <div class="step first" [ngClass]="displayBubbleStatus.Initiated_step">
                            <img src="assets/images/initiated_icon.svg" alt="">
                          </div>
                        </div>

                      </li>
                      <li>
                        <div class="border-div">
                          <div class="step second" [ngClass]="displayBubbleStatus.Approval_step">
                            <img src="assets/images/approve_icon.svg" alt="">
                            <!-- <img src="assets/images/approve_icon_white.png" alt=""> -->
                          </div>
                        </div>
                      </li>
                      <li>
                        <div class="border-div">
                          <div class="step third" [ngClass]="displayBubbleStatus.PWRLinked_step">
                            <img src="assets/images/link_icon.svg" alt="">
                            <!-- <img src="assets/images/link_icon_white.png" alt=""> -->
                          </div>
                        </div>

                      </li>
                      <li>
                        <div class="border-div">
                          <div class="step fourth " [ngClass]="displayBubbleStatus.ExecutionStarted_step">
                            <img src="assets/images/execution_ongoing.svg" alt="">
                            <!-- <img src="assets/images/execution_ongoing_white.png" alt=""> -->
                          </div>
                        </div>
                      </li>
                      <li>
                        <div class="border-div">
                          <div class="step fifth" [ngClass]="displayBubbleStatus.ExecutionCompleted_step">
                            <img src="assets/images/sales_forse_icon.png" alt="">
                          </div>
                        </div>
                      </li>
                      <li>
                        <div class="border-div">
                          <div class="step sixth" [ngClass]="displayBubbleStatus.Verified_step">
                            <img src="assets/images/verified_icon.svg" alt="">
                          </div>
                        </div>
                      </li>
                      <!-- <li>
                        <div class="border-div">
                        <div class="step seventh">
                            <img src="assets/images/completed_icon.svg" alt="">
                        </div>
                        </div>
                    </li> -->

                    </ul>
                  </div>

                  <div class="d-flex w-100 mt-3 ">
                    <div class="col-md-6">
                      <div class="row">
                        <div class="col-md-2 pe-0 align-self-center">
                          <label class="required">CATEGORY</label>
                        </div>
                        <div class="col-md-4 ps-0">
                          <!-- <select class="form-select" aria-label="Default select example"
                                [disabled]="disableAfterReview || projectId > 0"
                                [(ngModel)]="projectModel.generalInfo.projectDetails.categoryId"
                                (change)="onSelectedCategory($event)">
                          <option selected="" value="0">Select Category</option>
                          <option *ngFor="let catg of categoryList;" [value]="catg.categoryID">
                            {{catg.categoryName}}
                          </option>
                        </select> -->
                          <p-multiSelect [options]="categoryList" [(ngModel)]="selectedCategories" name="category"
                            [showHeader]="true" [filter]="true" placeholder="Select Category"
                            [disabled]="disableAfterReview || disableAll" (ngModelChange)="onSelectedCategory($event)">
                            <ng-template pTemplate="header">
                              <div class="custom-multiselect-header">
                                <span style="padding-right: 5px;">SELECT ALL</span>
                              </div>
                            </ng-template>
                          </p-multiSelect>
                        </div>
                        <!-- <div class="col-md-6 align-self-center">
                        <span class="text-danger fw-bold">Note : Once the project is created, the category cannot be changed.</span>
                      </div> -->
                      </div>

                    </div>
                    <div class="col-md-6 text-end align-self-center">
                      <div class="row">
                        <div class="col-md-12 pe-0 d-flex w-100 justify-content-end">
                          <label class="me-2">INITIATED BY</label>
                          <p class="font-13 mb-0">{{userDisplayName}}</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="menuSec mt-1">
                    <nav class="navbar navbar-expand-lg bg-white shadow-none py-0 mb-0 ms-0 border-0">

                      <div class="collapse navbar-collapse" id="navbarNav">
                        <ul class="navbar-nav mr-auto subnavLink">
                          <li class="nav-item me-3">
                            <a class="nav-link active w-150" href="#generalInfo"
                              [class.active]="activeTab === 'generalInfo'">
                              GENERAL INFORMATION
                            </a>
                          </li>

                          <li class="nav-item me-3">
                            <a class="nav-link w-130" href="#actvityType" [class.active]="activeTab === 'actvityType'">
                              ACTIVITY TYPE
                            </a>
                          </li>
                          <li class="nav-item me-3">
                            <a class="nav-link  w-168" href="#fundingandcost"
                              [class.active]="activeTab === 'fundingandcost'">
                              FUNDING & COST ESTIMATES
                            </a>
                          </li>
                          <li class="nav-item  me-3">
                            <a class="nav-link w-130" href="#productInfo" [class.active]="activeTab === 'productInfo'">
                              PRODUCTS
                            </a>
                          </li>
                          <li class="nav-item me-3">
                            <a class="nav-link w-130" href="#materials" [class.active]="activeTab === 'materials'">
                              MATERIALS
                            </a>
                          </li>

                          <li class="nav-item me-3">
                            <a class="nav-link w-130" href="#instructions"
                              [class.active]="activeTab === 'instructions'">
                              INSTRUCTIONS
                            </a>
                          </li>

                          <li class="nav-item me-3">
                            <a class="nav-link w-130" href="#questionscriteria"
                              [class.active]="activeTab === 'questionscriteria'">
                              CRITERIA
                            </a>
                          </li>

                          <li class="nav-item me-3">
                            <a class="nav-link w-130" href="#attachments" [class.active]="activeTab === 'attachments'">
                              ATTACHMENTS
                            </a>
                          </li>

                          <li class="nav-item">
                            <a class="nav-link w-130" href="#approvals" [class.active]="activeTab === 'approvals'">
                              APPROVAL
                            </a>
                          </li>

                        </ul>
                      </div>

                    </nav>
                  </div>

                </div>


              </div>
            </div>


          </div>
        </div>
      </div>
    </section>
  </div>



  <div class="middleContent">
    <section class="mt-385px" id="generalInfo">
      <div class="container-fluid px-2">
        <div class="card border-0" style="border-radius: 0px 0px 5px 5px;">
          <div class="card-body pb-1 pt-4">
            <div class="row border-bottom">
              <div class="col-md-9  w-79per border-right-solid pb-4">
                <div class="row border-bottom">

                  <div class="col-md-5 pe-50px border-right-solid pb-4">
                    <!-- <fieldset [disabled]="disableAfterReview"> -->
                    <app-ginfo-project-details [selectedGenInfoProject]="projectModel.generalInfo.projectDetails"
                      [enablePWR]="enablePWR" [disableAfterReview]="disableAfterReview" [disableAll]="disableAll">
                    </app-ginfo-project-details>
                    <!-- </fieldset> -->
                  </div>
                  <div class="col-md-7 ps-50px pe-50px">
                    <fieldset [disabled]="disableAfterReview">
                      <app-common-store-list [vendorId]="vendorId" [refType]="refType" [purpose]="purposeStore"
                        [disableAfterReview]="disableAfterReview" [disableAll]="disableAll"
                        [selectedFile]="projectModel.generalInfo.storeList" [selStoreDetails]="projectModel.generalInfo"
                        (emitValueChanged)="onFileChanged($event);" (storeFileSelected)="onStoreFileChanged($event);"
                        [selectedCategoryList]="selectedCategories" [storesByStates]="selectedStoresByStates"
                        [identifiedStores]="selectedIdentifiedStoreNumbers"
                        (notifyIsoAdmin)="onNotifyIsoAdmin($event);">
                      </app-common-store-list>
                    </fieldset>
                  </div>
                </div>
                <div class="row ">
                  <div class="col-md-12">
                    <fieldset [disabled]="disableAll">
                      <!-- <app-ginfo-objective-goals [projectObjectives]="projectModel.projectObjectives"
                                               [projectTitle]="projectModel.generalInfo.projectDetails.projectTitle"
                                               (objectivesChanged)="objectivesChanged($event)"
                                               [disableAll]="disableAll"
                                               [disableAfterReview]="disableAfterReview">
                    </app-ginfo-objective-goals> -->
                      <div class="col-md-12 pb-1 pt-2" id="actvityType">
                        <h6 class="loginHeadingText text-start pt-4 mb-2">ACTIVITY TYPE</h6>
                        <div class="row row-cols-5">
                          <div class="col ps-1" *ngFor="let act of activities;let i = index">
                            <div class="form-check activityType">
                              <input class="form-check-input" type="checkbox" [checked]="act.isChecked"
                                [(ngModel)]="act.isChecked" [id]="getUnequeValue('flexCheckDefault',i)"
                                (ngModelChange)="onAnyFieldValueChange($event)"
                                [ngClass]="{'disabled-row': disableAll}">
                              <label class="form-check-label text-capitalize fs-14" for="flexCheckDefault">
                                {{act.name}}
                              </label>
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-md-6">
                            <!-- <h6 class="loginHeadingText text-start pt-4 mb-3">SCOPE OF WORK</h6> -->
                            <!-- <h6 class="loginHeadingText text-start pt-4 mb-3">PROJECT DETAILS</h6> -->
                            <label class="text-start pt-4 mb-2">PROJECT DETAILS</label>
                            <textarea class="form-control h-115 mb-2"
                              [(ngModel)]="projectModel.generalInfo.projectDetails.scopeOfWork!"
                              (ngModelChange)="onAnyFieldValueChange($event)" maxlength="32767"
                              spellcheck="false"></textarea>
                          </div>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                </div>
              </div>
              <div class="col-md-3 w-21per ps-50px">
                <!-- <fieldset [disabled]="disableAfterReview"> -->
                <app-ginfo-key-dates [keyDatesInfo]="projectModel.generalInfo.keyDates" [isSRETeam]="isSRETeam"
                  [projectApporval]="projectModel.projectApproval!" [selProjectStatus]="projectModel.projectStatus!"
                  [enablePWR]="enablePWR" [componentUsedBy]="refType" [disableAfterReview]="disableAfterReview"
                  [disableAll]="disableAll" [projectId]="projectModel.generalInfo.projectDetails.projectId"
                  (notifyExecutionProcess)="onExecutionProcess($event)" (emitValueChanged)="onKeyDatesChanged($event);">
                </app-ginfo-key-dates>
                <!-- </fieldset> -->
              </div>
            </div>

            <!--<fieldset [disabled]="disableAll">
            <div class="row border-bottom" id="actvityType">
              <div class="col-md-5 pe-50px pb-37px">
                <h6 class="loginHeadingText text-start pt-4 mb-3">SCOPE OF WORK</h6> 
                <textarea class="form-control h-115 mb-2" [(ngModel)]="projectModel.generalInfo.projectDetails.scopeOfWork!" (ngModelChange)="onAnyFieldValueChange($event)" maxlength="32767" spellcheck="false"></textarea>
              </div>
               <div class="col-md-7 ps-50px pb-4 pt-2">
                <h6 class="loginHeadingText text-start pt-4 mb-2">ACTIVITY TYPE</h6>
                <div class="row row-cols-5">
                  <div class="col ps-1" *ngFor="let act of activities;let i = index">
                    <div class="form-check activityType">
                      <input class="form-check-input" type="checkbox" [checked]="act.isChecked" 
                      [(ngModel)]="act.isChecked" 
                       [id]="getUnequeValue('flexCheckDefault',i)"
                       (ngModelChange)="onAnyFieldValueChange($event)"
                      [ngClass]="{'disabled-row': disableAll}">
                      <label class="form-check-label text-capitalize fs-14" for="flexCheckDefault">
                        {{act.name}}
                      </label>
                    </div>
                  </div>
                </div>
              </div> 
            </div>
          </fieldset>-->

            <!--<div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" [name]="getUnequeValue('inlineRadioOptions1',i)" value="Store" [(ngModel)]="item.storeOrRep" [id]="getUnequeValue('inlineRadio1',i)">
            <label class="form-check-label" for="inlineRadio1">STORE</label>
          </div>-->

            <fieldset [disabled]="disableAll">
              <div class="row border-bottom mb-0" id="fundingandcost">
                <div class="col-md-6 border-right-solid pe-50px pb-37px" *ngIf="isProjectModeDecided">
                  <app-project-cost-estimates [categoryId]="categoryId" [selectedCategories]="selectedCategories"
                    [storesCount]="storesCount" [selectedProjectCost]="projectModel.projectCost"
                    [projectId]="projectModel.generalInfo.projectDetails.projectId"
                    (notifyProjectCostEstimates)="onProjectCostEstimates($event);"
                    [thirdPartyAgencies]="thirdPartyAgencies" [isSRETeam]="isSRETeam">
                  </app-project-cost-estimates>
                </div>
                <div class="col-md-6 ps-50px">
                  <app-funding-rms [disableFields]="disableAfterReview"
                    [selectedFundingRMS]="projectModel.fundingAndRMSVM" [estimatedTotalCost]="newEstimationCost"
                    (notifyFundingRMSObject)="onChangeFundingRMS($event);">
                    >
                  </app-funding-rms>
                </div>
              </div>
            </fieldset>

            <fieldset [disabled]="disableAll">
              <div class="row border-bottom" id="productInfo">
                <div class="col-md-3">
                  <app-common-products-list [categoryId]="categoryId" [refType]="refType"
                    [selectedCategories]="selectedCategories"
                    [isProductListChecked]="!projectModel.generalInfo.projectDetails.isProductManual!"
                    [purpose]="purposeProducts" [selectedFile]="projectModel.products"
                    [isProductReviewChecked]="projectModel.generalInfo.projectDetails.isProductReviewConfirmed!"
                    [disableAfterReview]="disableAfterReview" (emitValueChanged)="onFileChanged($event);"
                    (productFileSelected)="onProductFileChanged($event);" (notifyParent)="onCommuncation($event);"
                    (notifyRButtonStatus)="onRButtonStatus($event);"
                    (notifyProductSelections)="onProductSelectionUpdate($event);"
                    [reciveCoomunication]="reciveCoomunication" [selectedCategoryList]="selectedCategories"
                    [selStoreDetails]="projectModel.generalInfo">
                  </app-common-products-list>
                </div>
                <div class="col-md-1 text-center">
                  <h6 class="orText mt-29">OR</h6>
                </div>
                <div class="col-md-8">
                  <app-common-product-list-manual [categoryId]="categoryId" [selectedCategories]="selectedCategories"
                    [selectedCategories]="selectedCategories"
                    [isProductListManualChecked]="projectModel.generalInfo.projectDetails.isProductManual!"
                    [componentUsedBy]="refType" [disableAfterReview]="disableAfterReview"
                    [selectedProductRows]="projectModel.productsManual"
                    (updatedProductRows)="onUpdatePRoductRows($event);" (notifyParent)="onCommuncation($event);"
                    (notifyRButtonStatus)="onRButtonStatus($event);"
                    (notifyProductSelections)="onProductSelectionUpdate($event);"
                    [reciveCoomunication]="reciveCoomunication" [categoryList]="categoryList"
                    [productItems]="productItems" [orgProductsList]="orgProductsList"
                    (onChangeAddProductCategoryID)="onChangeAddProductCategoryID($event)">
                  </app-common-product-list-manual>
                </div>
                <div class="col-md-12 text-end mb-4">
                  <button class="btn btn-sm btnReviewLog mt-2" data-bs-toggle="modal"
                    [disabled]="projectModel.generalInfo.projectDetails.projectId == 0 || !hasProductItems"
                    (click)="addItemReviewLogs()">REVIEW PRODUCT ITEM</button>
                  <div class="text-end"
                    *ngIf="projectModel.generalInfo.projectDetails.projectId > 0 && hasProductItems && productReviewedBy != ''">
                    <span class="d-inline">Reviewed By:
                      <strong>{{productReviewedBy}}</strong> On:
                      <strong>{{productReviewedDate | date:'dd-MMM-yyyy'}}</strong>
                    </span>&nbsp;
                  </div>
                </div>
              </div>
            </fieldset>

            <fieldset [disabled]="disableAll">
              <div class="row border-bottom" id="materials">
                <div class="d-flex align-items-center mb-3 pt-4">
                  <h6 class="loginHeadingText me-2 mb-0">MATERIALS LIST</h6>
                  <a (click)="showReminderDialog()">
                    <img src="assets/images/mail_icon.png" alt="email" class="emailicon" title="Send Reminder Email">
                  </a>
                </div>
                <div class="row mb-12px">
                  <div class="col-md-2 pe-0 align-self-center w-13">
                    <label for="">MARKETING MATERIALS</label>
                  </div>
                  <div class="col-md-8 activityType">
                    <input class="form-check-input" type="checkbox"
                      [checked]="projectModel.generalInfo.projectDetails.marketingMaterials"
                      (ngModelChange)="onAnyFieldValueChange($event)"
                      [(ngModel)]="projectModel.generalInfo.projectDetails.marketingMaterials" id="flexCheckDefault">
                  </div>
                </div>

                <div class="row mb-12px">
                  <div class="col-md-2 pe-0 align-self-center w-13">
                    <label for="">ARE YOU SHIPPING FROM</label>
                  </div>
                  <div class="col-md-8 ps-1 activityType">

                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" name="inlineRadioOptions"
                        (ngModelChange)="onAnyFieldValueChange($event)" id="inlineRadio1" value="RMS"
                        [(ngModel)]="projectModel.generalInfo.projectDetails.shippingFrom"
                        (change)="onRmsSelect($event)">
                      <label class="form-check-label" for="inlineRadio1">RMS</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2"
                        value="Direct To Store" [(ngModel)]="projectModel.generalInfo.projectDetails.shippingFrom"
                        (change)="onDirectToStoreSelect($event)">
                      <label class="form-check-label" for="inlineRadio2">Direct To Store </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" name="inlineRadioOptions"
                        (ngModelChange)="onAnyFieldValueChange($event)" [disabled]="this.agencyName !== 'Anderson'"
                        id="inlineRadio3" value="ShopCOMM"
                        [(ngModel)]="projectModel.generalInfo.projectDetails.shippingFrom"
                        (change)="onShopCommSelect($event)">
                      <label class="form-check-label" for="inlineRadio3">ShopCOMM (Anderson)</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" name="inlineRadioOptions"
                        (ngModelChange)="onAnyFieldValueChange($event)" id="inlineRadio3"
                        value="Other (consult with ISO)"
                        [(ngModel)]="projectModel.generalInfo.projectDetails.shippingFrom"
                        (change)="onOtherSelect($event)">
                      <label class="form-check-label" for="inlineRadio3">Other (consult with ISO)</label>
                    </div>

                  </div>
                </div>

                <div class="row mb-15px">
                  <div class="col-md-2 pe-0 align-self-center w-13">

                  </div>
                  <div class="col-md-3 activityType">
                    <div class="lightBg">
                      <p class="mb-1"><strong>RMS & ShopComm : </strong> Must deliver 12 days prior to activity start
                        date</p>
                      <p class="mb-1"><strong>Direct to Store : </strong> Two Days prior to activity start date</p>
                    </div>
                  </div>

                  <div class="col-md-1 align-self-center text-center">
                    <a *ngIf="isShopComButtonVisible" (click)="downloadShopCOMMWordDocument($event)"
                      style="text-decoration: none; cursor: pointer;">
                      <img src="assets/images/word.png" class="w-30" alt="">
                      <p style="color:#0c9ef1;" class="mb-0">ShopCOMM_{{this.agencyName}}</p>
                    </a>
                  </div>



                </div>

                <div class="row mb-12px">
                  <div class="col-md-2  w-13">
                    <label for="">RMS #</label>
                  </div>
                  <div class="col-md-2">
                    <ng-container *ngFor="let rms of projectModel.generalInfo.materialRMS;">
                      <div class="d-flex mb-3" *ngIf="rms.status!='RMSRemove'">
                        <!-- <ng-container *ngIf="rms.status!='RMSRemove'"> -->
                        <div class="align-self-center me-2" a>
                          <img src="assets/images/plus_icon.svg" alt="" (click)="addRMSItem()" class="cursorpointer"
                            [ngClass]="{'disabled-row': isRMSSelected}">
                        </div>

                        <input type="text" class="form-control no-spinners" [(ngModel)]="rms.rmsNumber"
                          [disabled]="isRMSSelected" (input)="validateRMSNumber($event,rms)"
                          (ngModelChange)="onAnyFieldValueChange($event)" pattern="[a-zA-Z0-9]*">

                        <div class="align-self-center ms-2">
                          <img *ngIf="showDeleteRMSIcon" src="assets/images/close_mark.svg" alt=""
                            (click)="removeRMSItem(rms)" class="cursorpointer"
                            [ngClass]="{'disabled-row': isRMSSelected}">
                        </div>
                        <!-- </ng-container> -->
                      </div>
                    </ng-container>
                    <!-- <div class="d-flex mb-3" *ngIf="!projectModel.generalInfo.materialRMS || (projectModel.generalInfo.materialRMS && projectModel.generalInfo.materialRMS.length==0)">
                    <div class="align-self-center me-2" [ngClass]="{'disabled-row': isRMSSelected}">
                        <img src="assets/images/plus_icon.svg" alt="" (click)="addRMSItem()" class="cursorpointer">
                        </div>
    
                      <input type="text" class="form-control no-spinners" [(ngModel)]="projectModel.generalInfo.projectDetails.rmsNumber" [disabled]="isRMSSelected"
                             (input)="validateRMSNumber($event)" pattern="[a-z0-9]*"  >
    
                </div>                         -->

                  </div>
                </div>



                <div class="row mb-12px ">
                  <div class="col-md-2 align-self-center w-13">
                    <label for="">SHOPCOMM ITEM #</label>
                  </div>
                  <div class="col-md-2 pad-35px">
                    <input type="text" class="form-control no-spinners" min="0"
                      [(ngModel)]="projectModel.generalInfo.projectDetails.shopCommItemNumber"
                      [disabled]="isShopCommSelected || this.agencyName !== 'Anderson'"
                      (input)="validateShopComNumber($event)" (ngModelChange)="onAnyFieldValueChange($event)"
                      pattern="[a-z0-9]*">
                  </div>
                </div>

                <div class="row mb-15px">
                  <div class="col-md-2 align-self-center w-13">
                    <label for="">DUE TO SHIPPING FACILITY</label>
                  </div>
                  <div class="col-md-2 pad-35px">
                    <!-- removed date restriction [minDate]="minDate || undefined" -->
                    <p-calendar dateFormat="dd-M-yy" [style]="{'width':'100%','margin-top':'3px'}"
                      [(ngModel)]="projectModel.generalInfo.projectDetails.dueToShippingFacility"
                      (ngModelChange)="onShippingDateChange($event)" [ngClass]="{'disabled-row': disableAll}">
                    </p-calendar>
                  </div>
                </div>

                <div class="col-md-12">
                  <div class=" col-md-1 pull-right">
                    <div class="text-center">
                      <a (click)="exportMaterialExcel()"
                        style="text-decoration: none; cursor: pointer; margin-left: 92px;" title="Export to Excel">
                        <img src="assets/images/export.png" class="w-30" alt="" style="margin-bottom: -10px;">
                        <!--<p style="color:#0c9ef1;" class="mb-0">Export to Excel</p>-->
                      </a>
                    </div>
                  </div>
                </div>

                <div class="row pe-0" [ngClass]="{'disabled-row': disableAll}">
                  <div class="col-md-12 pe-0 pb-2">
                    SHOPCOMM ITEM #
                    <table class="table datatable border-x-0 mb-0">
                      <tbody>
                        <tr class="subheaderrr">
                          <th width="1%"></th>
                          <th width="13%">MATERIAL TYPE</th>
                          <th width="28%"> MATERIAL DESCRIPTION</th>
                          <th width="10%"># STORES</th>
                          <th width="10%">QTY. PER STORE</th>
                          <th width="10%">ARTICLE #</th>
                          <th width="10%"> TOTAL QTY.</th>
                          <th class="border-end-0" width="2%"></th>
                        </tr>

                        <tr *ngFor="let item of projectModel?.projectMaterials; let i = index">
                          <td class="align-middle">
                            <img src="assets/images/plus_icon.svg" alt="" (click)="addMaterialItem(i+1)">
                          </td>
                          <td>
                            <select class="form-select" aria-label="Default select example"
                              (ngModelChange)="onAnyFieldValueChange($event)" [(ngModel)]="item.materialID"
                              (change)="materialDescription(item,i)">
                              <option selected="">Select</option>
                              <option *ngFor="let mstMaterial of distinctMaterials" [value]="mstMaterial.materialID">
                                {{mstMaterial.materialType}}</option>
                            </select>
                          </td>
                          <td>
                            <div class="form-control" style="min-height: 32px;"
                              [ngClass]="{'disabled-row': disableAll}">
                              {{item.materialDescription}}
                              <!--<select class="form-select" aria-label="Default select example" [(ngModel)]="item.materialDescriptionID">
                            <option selected="">Select</option>
                            <option *ngFor="let mstMaterial of mstMaterials" [value]="mstMaterial.materialID">{{mstMaterial.materialName}}</option>
                            </select>-->
                            </div>
                          </td>
                          <!-- (keypress)="onKeyPress($event)" -->
                          <!-- (keypress)="onKeyPress($event)" -->
                          <td>
                            <input type="number" class="form-control" (ngModelChange)="onAnyFieldValueChange($event)"
                              [(ngModel)]="item.numberOfStores" (input)="onNumberOfStores($event, i)">
                          </td>
                          <td>
                            <input type="number" class="form-control" (ngModelChange)="onAnyFieldValueChange($event)"
                              [(ngModel)]="item.qtyPerStore">
                          </td>
                          <td>
                            <input type="text" class="form-control" (ngModelChange)="onAnyFieldValueChange($event)"
                              [(ngModel)]="item.article" maxlength="200">
                          </td>
                          <td>
                            <input type="text" class="form-control"
                              [value]="(item.numberOfStores ?? 0) * (item.qtyPerStore ?? 0)" [disabled]="true">
                          </td>
                          <td *ngIf="checkProjectMaterialLength() == 1">
                          </td>
                          <td *ngIf="checkProjectMaterialLength() > 1" class="col align-self-center text-center">
                            <img src="assets/images/close_mark.svg" alt="" (click)="removeMaterialItem(i)">
                          </td>
                        </tr>

                      </tbody>
                    </table>
                  </div>
                </div>

              </div>
            </fieldset>


            <div class="col-md-12 border-bottom mb-0" id="instructions">
              <!--<p>projectTemplateInstructions count: {{ projectModel.projectTemplateInstructions!.length }}</p>-->
              <app-instructions [disableFields]="disableAll" [selectedInstructionsVM]="projectModel.instructionsVM"
                [projectTemplateInstruction]="projectModel.projectTemplateInstructions"
                (notifyInstructionsObject)="onChangeInstructions($event);"
                (selectedTemplateData)="onChangeTemplateData($event);" [selectedCategoryList]="selectedCategories"
                [selStoreDetails]="projectModel.generalInfo">
              </app-instructions>
            </div>

            <fieldset [disabled]="disableAfterReview">
              <div class="row border-bottom mt-2" id="questionscriteria" [ngClass]="{'disabled-row': disableAll}">
                <!-- <div class="col-md-6">
                <app-agency-questions [disableAfterReview]="disableAfterReview">
                </app-agency-questions>
              </div>              -->
                <div class="col-md-11" *ngIf="isValidationCriteria">
                  <app-sre-validation-criteria [disableAfterReview]="disableAll"
                    [selectedValidationCriteriaRows]="projectModel.projectValidationCriterias"
                    (updateValidationCriteriaRows)="onUpdateValidationCriteria($event);">
                  </app-sre-validation-criteria>
                </div>
              </div>
            </fieldset>

            <fieldset>
              <div class="row border-bottom mb-0 pt-40" id="attachments">
                <h6 class="loginHeadingText text-start pt-1">ATTACHMENTS</h6>
                <div class="row mb-0">
                  <div class="col-md-1 w-10 ">
                    <label for="">UPLOAD ATTCHMENTS</label>
                  </div>
                  <div class="col-md-3 w-20">
                    <div class="input-group custom-file-button">
                      <input [disabled]="disableAll" type="file" class="form-control" id="inputGroupFile" multiple
                        #fileInputs (change)="onFileSelected($event)">
                      <label class="input-group-text" for="inputGroupFile">UPLOAD</label>
                    </div>
                  </div>

                  <div class="col-md-8 w-70">
                    <div class="d-flex w-1000 pt-2" style="margin-top: -12px">
                      <div class="me-3 w-10"
                        *ngFor="let row of this.projectModel.projetAttachmentFiles; let i = index;">
                        <div class="position-relative w-35 m-auto" [ngClass]="{'disabled-row': disableAfterReview}">
                          <img src="assets/images/close_icon.svg" class="docCloseIcon" alt=""
                            (click)="onDeleteAttachmentFiles(i)">
                          <img src="assets/images/document_icon.svg" alt="">
                          <span class="docText">{{i+1}}</span>
                        </div>
                        <div>
                          <p style="color:#0c9ef1; text-align:center" class="mb-0"
                            (click)="downLoadFilePreview($event, i)">
                            {{row.fileName}}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-12">
                    <div class=" col-md-1 pull-right">
                      <div class="text-center">
                        <a (click)="downloadAttachmentFilesAsZip()"
                          style="text-decoration: none; cursor: pointer; margin-left: 103px;" title="Export to Zip">
                          <img src="assets/images/export.png" class="w-30" alt="" style="margin-bottom: -10px;">
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12 pe-0 mt-3" [ngClass]="{'disabled-row': disableAll}">
                    <table class="table datatable border-x-0 mb-0">
                      <tbody>
                        <tr class="subheaderrr">
                          <th width="1%"></th>
                          <th width="32%">DESCRIPTION</th>
                          <th width="11%">STORE OR REP OR AGENCY</th>
                          <th width="8%">PRINT OR VIEW</th>
                          <th width="6%">PAGE COUNT</th>
                          <th class="border-end-0" width="2%"></th>
                        </tr>
                        <tr *ngFor="let item of projectModel?.projectAttachments; let i = index">
                          <td class="align-middle">
                            <img src="assets/images/plus_icon.svg" alt="" (click)="addAttachmentsItem(i+1)">
                          </td>
                          <td>
                            <input type="text" class="form-control" (ngModelChange)="onAnyFieldValueChange($event)"
                              [(ngModel)]="item.description" maxlength="500" [ngClass]="{'disabled-row': disableAll}">
                          </td>
                          <td class="text-center">
                            <div class="form-check form-check-inline">
                              <input class="form-check-input" type="radio"
                                (ngModelChange)="onAnyFieldValueChange($event)"
                                [name]="getUnequeValue('inlineRadioOptions1',i)" value="Store"
                                [(ngModel)]="item.storeORRep" [id]="getUnequeValue('inlineRadio1',i)"
                                [ngClass]="{'disabled-row': disableAll}">
                              <label class="form-check-label" for="inlineRadio1">STORE</label>
                            </div>
                            <div class="form-check form-check-inline">
                              <input class="form-check-input" type="radio"
                                [name]="getUnequeValue('inlineRadioOptions1',i)" value="Rep"
                                [(ngModel)]="item.storeORRep" [id]="getUnequeValue('inlineRadio2',i)"
                                [ngClass]="{'disabled-row': disableAll}">
                              <label class="form-check-label" for="inlineRadio1">REP</label>
                            </div>
                            <div class="form-check form-check-inline">
                              <input class="form-check-input" type="radio"
                                [name]="getUnequeValue('inlineRadioOptions1',i)" value="AGENCY"
                                [(ngModel)]="item.storeORRep" [id]="getUnequeValue('inlineRadio3',i)"
                                [ngClass]="{'disabled-row': disableAll}">
                              <label class="form-check-label" for="inlineRadio1">AGENCY</label>
                            </div>
                          </td>
                          <td class="text-center">
                            <div class="form-check form-check-inline">
                              <input class="form-check-input" type="radio"
                                [name]="getUnequeValue('inlineRadioOptions',i)" value="Print"
                                [(ngModel)]="item.printORView" [id]="getUnequeValue('inlineRadio3',i)"
                                [ngClass]="{'disabled-row': disableAll}">
                              <label class="form-check-label" for="inlineRadio2">PRINT</label>
                            </div>
                            <div class="form-check form-check-inline">
                              <input class="form-check-input" type="radio"
                                [name]="getUnequeValue('inlineRadioOptions',i)" value="View"
                                [(ngModel)]="item.printORView" [id]="getUnequeValue('inlineRadio4',i)"
                                [ngClass]="{'disabled-row': disableAll}">
                              <label class="form-check-label" for="inlineRadio2">VIEW</label>
                            </div>
                          </td>
                          <td>
                            <input type="text" class="form-control" [(ngModel)]="item.pageCount"
                              [ngClass]="{'disabled-row': disableAll}">
                          </td>
                          <td *ngIf="checkProjectAttachmentLength() == 1">
                          </td>

                          <td *ngIf="checkProjectAttachmentLength()>1" class="col align-self-center text-center">
                            <img src="assets/images/close_mark.svg" alt="" (click)="removeAttachmentsItem(i)">
                          </td>
                        </tr>

                      </tbody>
                    </table>
                  </div>


                </div>
              </div>
            </fieldset>

            <div class="row mb-15px  pt-40" id="approvals">
              <app-common-approval [componentUsedBy]="refType" [disableAfterReview]="disableAfterReview"
                [projectId]="projectModel.generalInfo.projectDetails.projectId"
                [selApprovalVM]="projectModel.projectApproval" [selProjectStatus]="projectModel.projectStatus"
                [projectStatusList]="projectModel.projectStatuses" [allStatusList]="projectModel!.projectStatusMaster!"
                (notifyBubbleStatus)="onBubbleStatusChanged($event);"
                (emitKeyValueChangesAfterReviewRequest)="KeyValueChangesAfterReviewRequest($event);"
                (notifyReadyForReviewClicked)="ReadyForReview($event);" [categoryid]="catgId" [disableAll]="disableAll"
                [selectedFundingRMS]="projectModel.fundingAndRMSVM">
              </app-common-approval>
            </div>




          </div>
        </div>


      </div>
    </section>

  </div>


  <!-- Scrollable modal -->
  <!-- Button trigger modal -->
  <!-- Modal -->
  <div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-scrollable modal-xl">
      <div class="modal-content">
        <div class="modal-header py-2">
          <h1 class="modal-title modalTitle" id="staticBackdropLabel">TEMPLATE 1</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body pb-2">
          <div class="row mb-2">
            <div class="col-md-8">
              <h6 class="searchByText ">DRAG & DROP IMAGES AND TYPE IN YOUR INSTRUCTIONS</h6>
            </div>
            <div class="col-md-4 text-end">
              <a href="#" class="fw-bold" style="color:#0c9ef1; text-decoration: none;"></a>
            </div>
          </div>
          <div class="row pb-3">
            <div class="col-md-12">
              <textarea class="form-control imgInfo mb-4" placeholder="Enter Instructions" name="" id="" cols="30"
                rows="30"></textarea>
            </div>
            <div class="col-md-6">
              <div class="drogdroupbox h-160">
                <img src="assets/images/img_drog.svg" alt="">
              </div>
            </div>
            <div class="col-md-6">
              <div class="drogdroupbox h-160">
                <img src="assets/images/img_drog.svg" alt="">
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <!-- <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button> -->
          <button class="btn progressBtn ps-2" role="button">
            PREVIEW PDF FILE
          </button>
        </div>
      </div>
    </div>
  </div>


  <div class="modal fade" id="staticBackdrop_two" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-labelledby="staticBackdrop_twoLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-scrollable modal-xl">
      <div class="modal-content">
        <div class="modal-header py-2">
          <h1 class="modal-title modalTitle" id="staticBackdrop_twoLabel">TEMPLATE 2</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body pb-2">
          <div class="row mb-2">
            <div class="col-md-8">
              <h6 class="searchByText ">DRAG & DROP IMAGES AND TYPE IN YOUR INSTRUCTIONS</h6>
            </div>
            <div class="col-md-4 text-end">
              <a href="#" class="fw-bold" style="color:#0c9ef1; text-decoration: none;"></a>
            </div>
          </div>
          <div class="row pb-2">
            <div class="col-md-4 mb-15px">
              <!-- <img src="assets/images/drogdroupImg.png" class="img-fluid" alt=""> -->
              <div class="drogdroupbox">
                <img src="assets/images/img_drog.svg" alt="">
              </div>
            </div>
            <div class="col-md-8 ps-2 mb-15px">
              <textarea class="form-control imgInfo" placeholder="Enter Instructions" name="" id="" cols="30"
                rows="10"></textarea>
            </div>


            <div class="col-md-4 mb-15px">
              <!-- <img src="assets/images/drogdroupImg.png" class="img-fluid" alt=""> -->
              <div class="drogdroupbox">
                <img src="assets/images/img_drog.svg" alt="">
              </div>
            </div>
            <div class="col-md-8 ps-2 mb-15px">
              <textarea class="form-control imgInfo" placeholder="Enter Instructions" name="" id="" cols="30"
                rows="10"></textarea>
            </div>


            <div class="col-md-4">
              <!-- <img src="assets/images/drogdroupImg.png" class="img-fluid" alt=""> -->
              <div class="drogdroupbox">
                <img src="assets/images/img_drog.svg" alt="">
              </div>
            </div>
            <div class="col-md-8 ps-2 ">
              <textarea class="form-control imgInfo" placeholder="Enter Instructions" name="" id="" cols="30"
                rows="10"></textarea>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <!-- <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button> -->
          <button class="btn progressBtn ps-2" role="button">
            PREVIEW PDF FILE
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="staticBackdrop_three" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-labelledby="staticBackdrop_threeLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-scrollable modal-xl">
      <div class="modal-content">
        <div class="modal-header py-2">
          <h1 class="modal-title modalTitle" id="staticBackdrop_threeLabel">TEMPLATE 3</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body pb-2">
          <div class="row mb-2">
            <div class="col-md-8">
              <h6 class="searchByText ">DRAG &amp; DROP IMAGES AND TYPE IN YOUR INSTRUCTIONS</h6>
            </div>
            <div class="col-md-4 text-end">
              <a href="#" class="fw-bold" style="color:#0c9ef1; text-decoration: none;"></a>
            </div>
          </div>
          <div class="row mb-1 pb-2">
            <div class="col-md-6">
              <div class="drogdroupbox h-160">
                <img src="assets/images/img_drog.svg" alt="">
              </div>
            </div>
            <div class="col-md-6">
              <textarea class="form-control imgInfo mb-4 h-159" placeholder="Enter Instructions"></textarea>
            </div>

            <div class="col-md-3">
              <div class="drogdroupbox h-160">
                <img src="assets/images/img_drog.svg" alt="">
              </div>
            </div>
            <div class="col-md-3">
              <div class="drogdroupbox h-160">
                <img src="assets/images/img_drog.svg" alt="">
              </div>
            </div>
            <div class="col-md-6">
              <textarea class="form-control imgInfo mb-4 h-159" placeholder="Enter Instructions"></textarea>
            </div>

            <div class="col-md-12">
              <textarea class="form-control imgInfo  h-159" placeholder="Enter Instructions"></textarea>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <!-- <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button> -->
          <button class="btn progressBtn ps-2" role="button">
            PREVIEW PDF FILE
          </button>
        </div>
      </div>
    </div>
  </div>
</fieldset>

<p-confirmDialog position="top" [baseZIndex]="200000" appendTo="body" role="alertdialog"></p-confirmDialog>